import React, { useRef, useEffect } from 'react';
import { useState } from 'react';
import { Button } from 'primereact/button';


// import { Steps } from 'primereact/steps';
// import { read, utils } from "xlsx";
// import { Button } from 'primereact/button';
// import UploadComponent from './UploadComponent';
// import DataTableComponent from '../../components/DataTable';
// import StepsNavigation from '../../components/StepsNavigation';
// import { InputText } from 'primereact/inputtext';
// import AlertComponent from '../../components/Alert';
// import Reviewsubmit from './Reviewsubmit';


// Import Styles
import '../../styles/pages/addcsv.scss';

//  Import the Sample Table component
import SamplesTable from '../../components/DataSamplesTable';

// Import the Data Search component
import DataSearch from '../../components/DataSearch';




function FailedSampleManagement() {
    // const [samples, setSamples] = useState([]);
    const [columns, setColumn] = useState([]);
    const [loading, setLoading] = useState(false)
    const [keys, setKeys] = useState([]);
    const dataTableLoaded = useRef(false);
    const [bulkJson, setBulkJson] = useState([]);
    const [csvErrors, setCSVErrors] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    const StepperProps = { activeIndex: activeIndex, setActiveIndex: setActiveIndex };
    const alertProps = { errors: [], alert: [], success: [] }

    useEffect(() => {
        document.title = `Data -> Failed Samples | Palmona Pathogenomics`
    }, []);


    // Add an attribute to a sample selected in the SamplesTable
    const addAttribute = () => {

    }

    // Add a new Sample to the Dataset
    const addSample = () => {

    }

    // Remove a Sample from the Dataset
    const removeSample = () => {

    }

    const [modal, setModal] = useState(false);
    const [error, setError] = useState("")

    const samples = [
        {
            id: 1,
            sample: 'Sample1B',
            date: '22/06/2023',
            file1: 'B_1.fastq.gz',
            file2: 'B_2.fastq.gz',
            longitude: '-73.436525',
            latitude: '12.976382',
            origin: 'Breath',
            transmissionRate: 'High'
        },
        {
            id: 2,
            sample: 'Sample1C',
            date: '23/06/2023',
            file1: 'C_1.fastq.gz',
            file2: 'C_2.fastq.gz',
            longitude: '-122.489664',
            latitude: '40.458120',
            origin: 'Air',
            transmissionRate: 'Low'
        },
        {
            id: 3,
            sample: 'Sample1D',
            date: '24/06/2023',
            file1: 'D_1.fastq.gz',
            file2: 'D_2.fastq.gz',
            longitude: '-89.527261',
            latitude: '78.654922',
            origin: 'Sea',
            transmissionRate: 'High'
        },
        {
            id: 4,
            sample: 'Sample1E',
            date: '28/06/2023',
            file1: 'E_1.fastq.gz',
            file2: 'E_2.fastq.gz',
            longitude: '-117.463198',
            latitude: '43.873259',
            origin: 'Land',
            transmissionRate: 'Extremely High'
        },
        {
            id: 5,
            sample: 'Sample1F',
            date: '12/06/2023',
            file1: 'F_1.fastq.gz',
            file2: 'F_2.fastq.gz',
            longitude: '-54.983570',
            latitude: '93.461209',
            origin: 'Blood',
            transmissionRate: 'Low'
        },
        {
            id: 6,
            sample: 'Sample1G',
            date: '12/06/2023',
            file1: 'G_1.fastq.gz',
            file2: 'G_2.fastq.gz',
            longitude: '-54.983570',
            latitude: '93.461209',
            origin: 'Blood',
            transmissionRate: 'Low'
        }
    ];
    return (
        <main className='mt-2'>
            <div className="d-flex justify-content-between">
                <div className="h5">Failed Samples</div>
                <div className=''>
                    <DataSearch />
                </div>
                <div className='ml-3 mr-3'>
                    {/* <Button className="pi pi-plus mr-2" label="Attribute" severity="warning" outlined />
                    <Button className="pi pi-plus mr-2" label="Sample" severity="warning" outlined /> */}
                </div>
            </div>
            <div className='mt-2 pt-2 mb-0 pb-0'>
                <span><strong>Total { samples.length } quality check passed samples are available to configure the workflow.</strong></span>
            </div>

            <div>
                <SamplesTable samples={ samples } />
            </div>
        </main>
    );
}

export default FailedSampleManagement;